import ApiError from "../../errors/ApiError";
import { LINK_CUSTOMER_KROSS_API_ERROR } from "./error-codes.constants";

export class LinkCustomerKrossApiError extends ApiError {
  constructor() {
    super(LINK_CUSTOMER_KROSS_API_ERROR);
  }
}
